import { Tooltip } from "../Tooltip/index.js";
import { COLORS_PRESET } from "./Tag.type.js";
import { hexToRgba } from "./hexToRgba.js";
import TagInList from "./TagInList.component.js";
import React, { forwardRef } from "react";
import { IconClose } from "@synthesis/shared-icons";
import { cn } from "@synthesis/shared-utils";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/Tag/index.tsx
/**
* Компонент Tag из нового UI Kit'a.
* Дизайн: https://www.figma.com/file/uRPlsieHFpRpRsYDX2KV1Q/%D0%90%D1%81%D1%83%D0%B1%D0%B8%D0%BC.-%D0%A0%D0%96%D0%94-UI-Kit?node-id=428%3A5016&t=cCZPVYNRl5Mcn0FE-0
*/
const tagSizeMap = {
	sm: "px-2 py-px leading-6",
	md: "px-3 py-1 leading-6",
	status: "h-8 min-h-8 px-3 subtitle-sm leading-5"
};
const tagContentGapMap = {
	sm: "gap-1",
	md: "gap-1",
	status: "gap-2"
};
const tagLeftIconClassNameMap = {
	sm: void 0,
	md: void 0,
	status: "[&_svg]:size-5"
};
const statusClassName = {
	SUCCESS: "bg-system-success-90 text-system-success-50",
	IN_QUEUE: "bg-additional-blue-90 text-additional-blue-50",
	TO_REUPLOAD: "bg-system-attention-90 text-system-attention-50",
	ERROR: "bg-system-error-90 text-additional-red-50",
	NEUTRAL: "bg-neutrals-95 text-type-minor"
};
const TagComponent = forwardRef(({ as: Component = "figure", children, size = "md", color = "blue", customColor, status, leftIcon, className, tooltipDescription, tooltipTitle, handleDelete, style, ...props }, ref) => {
	const isDeletable = Boolean(handleDelete);
	const customColorStyles = customColor && !status ? {
		backgroundColor: hexToRgba(customColor, .1),
		color: customColor === "#ffffff" ? "#000000" : customColor
	} : void 0;
	const content = /* @__PURE__ */ jsxs("span", {
		className: cn("inline-flex w-full min-w-0 items-center transition-all duration-100 ease-in", tagContentGapMap[size], isDeletable && "group-hover:max-w-[calc(100%-10px)]"),
		children: [leftIcon && /* @__PURE__ */ jsx("span", {
			className: cn("flex shrink-0 items-center", tagLeftIconClassNameMap[size]),
			children: leftIcon
		}), /* @__PURE__ */ jsx("span", {
			className: "inline-block truncate",
			children
		})]
	});
	return /* @__PURE__ */ jsxs(Component, {
		ref,
		className: cn("group relative m-0 inline-flex max-w-full items-center overflow-hidden rounded-lg", tagSizeMap[size], status ? statusClassName[status] : !customColor && COLORS_PRESET[color], className),
		style: {
			...style,
			...customColorStyles
		},
		...props,
		children: [tooltipTitle || tooltipDescription ? /* @__PURE__ */ jsx(Tooltip, {
			title: tooltipTitle,
			description: tooltipDescription ?? "",
			children: content
		}) : content, isDeletable && /* @__PURE__ */ jsx("button", {
			type: "button",
			className: cn("absolute right-1 ml-1 flex min-w-4 translate-x-full cursor-pointer items-center justify-center border-0 bg-transparent p-0 opacity-0", "hover:text-additional-red-50 transition-all duration-100 ease-in group-hover:translate-x-0 group-hover:opacity-100"),
			onClick: handleDelete,
			children: /* @__PURE__ */ jsx(IconClose, { className: "size-4" })
		})]
	});
});
const Tag = React.memo(TagComponent);
Tag.displayName = "Tag";
//#endregion
export { COLORS_PRESET, Tag, TagInList };

//# sourceMappingURL=index.js.map